import React from 'react'

import styled from 'styled-components/macro'
import { connect } from 'react-redux'
import useTranslation from 'next-translate/useTranslation'
import { GetServerSidePropsContext } from 'next'

import { Text } from '@/components/Text'

import { PageLayout } from '@/components/Layout/PageLayout'
import { Path } from '@/components/Path'

import { initializeStore } from '../redux/store'
import { getSettings } from '../redux/actions'

import { ColorsMap } from '@/utils/Theme'

import { StateInterface } from '@/types/State'
import { file } from '@babel/types'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 14%;
  margin-bottom: 4rem;
`

const FILES = [
  {
    title: 'Sintra Šport logo',
    fileType: 'pdf',
    link: '/downloads/sintra_sport_logo.pdf',
  },
  {
    title: 'Sintra Šport logo',
    fileType: 'svg',
    link: '/downloads/sintra_sport_logo.svg',
  },
  {
    title: 'Hummel logo',
    fileType: 'pdf',
    link: '/downloads/hummel_logo.pdf',
  },
  {
    title: 'Hummel & Sintra Šport banner',
    fileType: 'pdf',
    link: '/downloads/hummel_sintra_sport_banner.pdf',
  },
]

const ContactPage = ({ state }) => {
  const { t } = useTranslation('common')

  return (
    <PageLayout title={`${t('title:downloads')} | ${state.settings.name}`}>
      <Path pathLinks={[<span>{t('for-download')}</span>]} />
      <Wrapper>
        <Text as="h1" fontSize="xl" textColor={ColorsMap.primary} fontWeight="bold" m="2.5rem auto">
          {t('for-download')}
        </Text>
        <DownloadLinksWrapper>
          {FILES.map((file) => (
            <div>
              <DownloadLink href={file.link} download>{file.title}</DownloadLink>{' '}
              <DownloadLinkFileType>(.{file.fileType})</DownloadLinkFileType>
            </div>
          ))}
        </DownloadLinksWrapper>
      </Wrapper>
    </PageLayout>
  )
}

const mapStateToProps = (state: StateInterface) => ({
  state,
})

export async function getServerSideProps(ctx: GetServerSidePropsContext) {
  const reduxStore = initializeStore({})
  const { dispatch } = reduxStore

  const token = ctx.req.cookies.token || null

  await dispatch(getSettings({ token }))
  return { props: { initialReduxState: reduxStore.getState() } }
}

export default connect(mapStateToProps)(ContactPage)

const DownloadLinksWrapper = styled.a`
    display: flex;
    flex-direction: column;
    gap: 1rem;
`

const DownloadLink = styled.a`
    text-decoration: underline;
    color: ${ColorsMap.black};
`

const DownloadLinkFileType = styled.span`
    text-decoration: none;
    color: ${ColorsMap.textDefault};
`
